<template>
  <div class="detail-audio" v-if="atSelectAudio !== ''">
    <img class="audio-bgc" :src="atSelectAudio.imageUrl" />
    <div class="audio-content">
      <div class="detail-cover">
        <div class="cover-route">
          <img
            class="music-audio-play"
            src="../../../../assets/images/music-audio-play.png"
            v-show="audioState"
          />
          <img
            class="music-audio-pasue"
            src="../../../../assets/images/music-audio-pasue.png"
            v-show="!audioState"
          />
          <img class="bgc" src="../../../../assets/images/cd-route.png" />
          <img
            :class="
              audioState
                ? 'audio-play audio-route course-img'
                : 'audio-pasue audio-route course-img'
            "
            :src="atSelectAudio.imageUrl"
          />
        </div>
      </div>
      <audio-controller
        :title="atSelectAudio.audioName"
        :src="atSelectAudio.audioUrl"
        :handleAudioPlay="handleAudioPlay"
        :switchPlayingStatusType="switchPlayingStatusType"
        :playingStatusType="playingStatusType"
        :monitorAudioEnded="monitorAudioEnded"
        :answerChapter="answerChapter"
      >
      </audio-controller>
    </div>
    <MediaList 
        :mediaList="audioList"
        :mediaState="audioState"
        :switchMedia="switchAudio"
        :atSelectMedia="atSelectAudio"
    />
  </div>
</template>

<script>
import AudioController from "../../../../components/AudioController";
import MediaList from './MediaList'
export default {
  props: {
    switchPlayingStatusType: {
      type: Function,
      default: () => console.log("切换音频"),
    },
    handleAudioPlay: {
      type: Function,
      default: () => console.log("点击播放"),
    },
    monitorAudioEnded: {
      type: Function,
      default: () => console.log("音频播放完了"),
    },
    playingStatusType: {
      type: Number,
      default: "",
    },

    audioState: {
      type: Boolean,
      default: false,
    },

    audioList: {
      type: Array,
      default: [],
    },
    atSelectAudio: {
      type: Object,
      default: "",
    },
    switchAudio: {
      type: Function,
      default: () => console.log("切换音频"),
    },
    answerChapter: {
      type: Function,
      default: () => console.log("切换下一个"),
    },
  },
  data() {
    return {};
  },

  watch: {
      atSelectAudio(item) {
          console.log('item', item)
          this.atSelectAudio = item
      }
  },

  components: {
    AudioController,
    MediaList
  },
};
</script>

<style lang="scss" scoped>
@import "@style/main.scss";

.audio-route {
  animation: audioCover 5s linear infinite;
  transition: all 5s;
  transform-origin: center;
}

.audio-play {
  animation-play-state: running;
}

.audio-pasue {
  animation-play-state: paused;
}

@keyframes audioCover {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}
.course-detail {
  .detail-audio {
    position: relative;

    .audio-bgc {
      width: 100%;
      height: rem(820);
      filter: blur(rem(50));
      position: relative;
      vertical-align: top;
    }

    .audio-content {
      position: absolute;
      width: 100%;
      height: rem(820);
      left: 0;
      top: 0;
      background: rgba($color: #000, $alpha: .1);

      .detail-cover {
        width: 100%;
        height: rem(480);
        display: flex;
        justify-content: center;
        align-items: flex-end;

        .cover-route {
          position: relative;
          width: rem(380);
          height: rem(380);
          .bgc {
            width: 100%;
            height: 100%;
          }

          .course-img {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            margin: auto;
            width: rem(240);
            height: rem(240);
            border-radius: 50%;
          }

          .music-audio-play {
            position: absolute;
            top: rem(-86);
            left: 0;
            right: 0;
            margin: auto;
            width: rem(113);
            height: rem(176);
            padding-left: rem(85);
            z-index: 9;
          }
          .music-audio-pasue {
            position: absolute;
            top: rem(-86);
            left: 0;
            right: 0;
            margin: auto;
            width: rem(180);
            height: rem(113);
            padding-left: rem(150);
            z-index: 9;
          }
        }
      }
    }
  }
}


</style>